import { render, staticRenderFns } from "./ClaimStaffs.vue?vue&type=template&id=9eb694fa&scoped=true"
import script from "./ClaimStaffs.vue?vue&type=script&lang=js"
export * from "./ClaimStaffs.vue?vue&type=script&lang=js"
import style0 from "./ClaimStaffs.vue?vue&type=style&index=0&id=9eb694fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb694fa",
  null
  
)

export default component.exports